import { render, staticRenderFns } from "./DesignProfilesSection.vue?vue&type=template&id=bd48090c&scoped=true"
import script from "./DesignProfilesSection.vue?vue&type=script&lang=js"
export * from "./DesignProfilesSection.vue?vue&type=script&lang=js"
import style0 from "./DesignProfilesSection.vue?vue&type=style&index=0&id=bd48090c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd48090c",
  null
  
)

export default component.exports